import React, { useEffect } from "react";
import NavbarLibrary from "../../Components/DigitalLibraryNew/NavbarLibrary";
import HeroLibrary from "../../Components/DigitalLibraryNew/HeroLibrary";
import LibraryRow from "../../Components/DigitalLibraryNew/LibraryRow";
import LoremSection from "../../Components/DigitalLibraryNew/LoremSection";
import BlueNotificationBanner from "../../Components/DigitalLibraryNew/BlueNotificationBanner";
import { scrollToTop } from "../../helper/helper";
import FooterNew from "../../Components/LandingNew/FooterNew";

export default function DigitalLibraryNew() {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white  flex flex-col justify-between">
      <div>
        {/* Navbar */}
        <NavbarLibrary />

        {/* Hero Section with crown banner and overview */}
        <HeroLibrary />

        {/* Rows of portrait cards */}
        <LibraryRow title="New This Week" />
        <LibraryRow title="Trending Now" />
        <LibraryRow title="Most You Like" />

        {/* Lorem : Lorem Ipsum section with 3 white play-button cards */}
        <LoremSection />

        {/* Blue notice banner */}
        <BlueNotificationBanner />
      </div>

      {/* Footer */}
      <FooterNew />
    </div>
  );
}
